import { decode } from 'he';

/**
 * Decodes HTML entities in a string
 * Handles common entities like &amp;, &lt;, &gt;, &quot;, &#39;, etc.
 */
export function decodeHtmlEntities(text: string): string {
  if (!text) {
    return text;
  }

  return decode(text);
}

/**
 * Server-safe version that works without DOM
 */
export function decodeHtmlEntitiesServer(text: string): string {
  if (!text) {
    return text;
  }

  const entities: Record<string, string> = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#x27;': "'",
    '&#x2F;': '/',
    '&#x60;': '`',
    '&#x3D;': '=',
  };

  return text.replace(/&[#\w]+;/g, (entity) => {
    return entities[entity] || entity;
  });
}
